<template>
  <div class="">
    <el-page-header class="page-header" @back="goBack" content="添加好友详情" >
      </el-page-header>
    <div class="customer-main">
    <div style="display: flex;flex-direction: row;justify-content: space-between;float: right;">
      <div class="nav-r nav-right">
        <div style="display: inline-block">
          <el-select clearable v-model="value2" placeholder="请选择状态" @change="rune()">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div>
          <el-input clearable style="width: 27.0rem; margin: 0 .0rem 0 2.0rem" placeholder="请输入手机号搜索"
            prefix-icon="el-icon-search" v-model="selectphone" @change="rune()">
          </el-input>
          <el-button slot="append" @click="rune()" type="primary">查询</el-button>
        </div>
      </div>
    </div>
    
    <el-table :data="tableData.data" border   style="width: 96%; margin-left: 3.0rem;margin-right: 3.0rem;">
      <el-table-column prop="name" label="客户姓名" style="width: 50%" >
      </el-table-column>
      <el-table-column prop="remark_mobiles" label="手机号" style="width: 50%" >
      </el-table-column>
      <el-table-column prop="is_status" label="添加状态" style="width: 10%" >
        <template slot-scope="scope">
          <div v-if="scope.row.if_copy == 1" style="color: #67c23a">
            <el-tag  type="success"  size="mini">已成功</el-tag> 
          </div>
          <div v-else style="color: #f56c6c">
            <el-tag type="danger" size="mini">未成功</el-tag> 
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createtime" label="添加时间" style="width: 50%"  width="240"></el-table-column>
      <el-table-column prop="account" label="操作人员" style="width: 50%" >
      </el-table-column>
      <el-table-column prop="phone" label="操作手机号" style="width: 50%" >
      </el-table-column>
      <el-table-column fixed="right" width="170" label="操作" >
        <template slot-scope="scope">
          <el-button @click="bianji(scope.row)" :type="(scope.row.if_copy == 1) ? 'info' : 'text'" size="mini"
            :disabled="scope.row.if_copy == 1" :plain="scope.row.if_copy == 1">提醒</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
    <div class="paging">
      <pagination :total="tableData.total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="userTable" />
    </div>

    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form"  label-width="8.0rem">
        <el-form-item label="添加" prop="name">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="名称" prop="none">
          <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: {
        total: 0,
        data: [],
      },
      selectphone: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      list: {},
      listQuery: {
        page: 1,
        limit: 20,
      },
      options: [
        {
          value: 3,
          label: '全部'
        },
        {
          value: 0,
          label: '未成功添加'
        },
        {
          value: 1,
          label: '已成功添加'
        }
      ],
      value2: ""
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // console.log(userinfo);
      this.tooken = userinfo;
    }
    this.list = this.$route.query.list;
    this.userTable();
    // console.log(this.tableData,'tabledata')
  },
  methods: {

    goBack() {
      this.$router.push("customerPhone");
    },
    handleCurrentChange(val) {
      this.axios
        .post(
          "/crm/CircleFriends/getPhoneByUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.list.userid,
            id: this.list.id,
            page: val,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    userTable() {
      this.axios
        .post(
          "/crm/CircleFriends/getPhoneByUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.list.userid,
            id: this.list.id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    rune() {
      this.axios
        .post(
          "/crm/CircleFriends/getPhoneByUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            remark_mobiles: this.selectphone,//查询手机号
            is_status: this.value2
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    tianjia() {
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    bianji(e) {
      this.axios
        .post(
          "/crm/CircleFriends/remindUser",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: e.account_id,
            userid: e.userid,
            remark_mobiles: e.remark_mobiles,
            id: e.task_id
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    // 修改
    numoon() {
      this.axios
        .post(
          "/crm/Source/editSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 添加
    numoo() {
      this.axios
        .post(
          "/crm/Source/addSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,

            phone: this.tooken.phone,
            name: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 移除
    handleClick(e, o) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Source/delSource",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) { });
        })
        .catch(() => { });
    },


  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}

nav {
  font-weight: 500;
  color: #19273c;
}

.shij {
  display: inline-block;
  margin-right: 4.0rem;
}

.nav-right {
  display: flex;
  margin: 3.0rem;
}
.el-table .el-button{
    background: none !important;
    color: #000 !important;
    font-size: 1.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #317AF8 !important;
    line-height: 2.2rem;
    padding-left: .0rem !important;
}

.title-customer-add{
  font-size: 2.4rem;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 3.3rem;
margin-bottom: 2.0rem;
}
.el-page-header{
  position: relative;
  top:-.4rem;
}


.customer-main{
  
background: #ffffff;
border-radius: .8rem .8rem 0 0 ;
}
.el-button--info{
  border:.0rem;
}
paging{
  border-radius: 0 0 .8rem .8rem;
}
</style>
